export default __webpack_public_path__ + "static/media/town.e436266f.png";